
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// MUI
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';

// DATA
import * as datasetActions from 'data/datasets/actions';
import { getDatasetsById, makeNewDataset, getLoadPending, isLoading, getError } from 'data/datasets/selectors';
import { getIsLoading as getProfileIsLoading, getLoadPending as getProfileLoadingPending } from 'data/profile/selectors';
import { authSelectDataset } from 'utils/auth/actions';
import { AuthSelectDatasetPayload } from 'utils/auth/types';
import store from 'store';

// custom
import tracker from 'utils/tracker';
import LoadingView from 'components/LoadingView';
import QButton from 'components/QButton';
import NaturalFlow from './flows/naturalFlow';


const styles = (theme) => ({
  dialogStyle: {
    zIndex: '1200 !important',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.greyScale[7],
    width: '100%',
    maxHeight: '100%',
    height: 500,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 3,
  },
});

class SetupPageAcme extends PureComponent { // eslint-disable-line react/prefer-stateless-function

  constructor(props) {
    super(props);

    this.state = { newDatasetClientId: undefined };

    if (!props.isDatasetsLoading) {
      props.dispatchGetDatasetsAction();
    }
  }

  render() {
    const { classes, datasets, isDatasetsLoadPending, dispatchCreateDatasetAction, isDatasetsLoading, isProfileLoading,
      isProfileLoadPending, datasetError, dispatchGetDatasetsAction } = this.props;
    const { newDatasetClientId } = this.state;

    const initNewDataset = () => {
      const newDataset = makeNewDataset(store.getState());
      tracker.track(tracker.events.datasetCreated);
      dispatchCreateDatasetAction(newDataset);
      this.setState({newDatasetClientId: newDataset.clientId});
    };

    // make sure dataset and profile has loaded
    if (!isDatasetsLoadPending && !isDatasetsLoading && !newDatasetClientId && datasets.size === 0 && !isProfileLoadPending && !isProfileLoading) {
      initNewDataset();
    } else if (newDatasetClientId) {
      const newDataSet = this.props.datasets.find((dataset) => newDatasetClientId === dataset.clientId);
      if (newDataSet && newDataSet.id) {
        this.setState({newDatasetClientId: undefined});
        this.props.dispatchSelectDatasetAction(new AuthSelectDatasetPayload({ dataset: newDataSet, reload: false, location: '/get-started' }));
      }
    }

    return (datasets.size === 0 ?
      <Dialog
        open
        fullWidth
        maxWidth="md"
        disableBackdropClick
        disableEscapeKeyDown
        disableEnforceFocus
        classes={{
          root: classes.dialogStyle,
        }}
      >
        <div className={classes.root}>
          {!isDatasetsLoading && datasets.size === 0 && datasetError ?
            <>
              <Typography variant="h4" style={{ paddingBottom: 24 }}>
                Oops!
              </Typography>
              <Typography variant="h6">
                {`We're having trouble ${isDatasetsLoadPending ? 'retrieving your dataset' : 'creating a dataset'}.`}
              </Typography>
              <QButton variant="contained" style={{ marginTop: 36 }} onClick={isDatasetsLoadPending ? dispatchGetDatasetsAction : initNewDataset}>
                Try Again
              </QButton>
            </>
            :
            <LoadingView />
          }
        </div>
      </Dialog>
      :
      <NaturalFlow />);
  }
}

SetupPageAcme.propTypes = {
  classes: PropTypes.object,
  dispatchCreateDatasetAction: PropTypes.func,
  dispatchGetDatasetsAction: PropTypes.func,
  datasets: PropTypes.object,
  datasetError: PropTypes.object,
  dispatchSelectDatasetAction: PropTypes.func,
  isDatasetsLoadPending: PropTypes.bool,
  isDatasetsLoading: PropTypes.bool,
  isProfileLoadPending: PropTypes.bool,
  isProfileLoading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    datasets: getDatasetsById(state),
    isDatasetsLoadPending: getLoadPending(state),
    isDatasetsLoading: isLoading(state),
    isProfileLoadPending: getProfileLoadingPending(state),
    isProfileLoading: getProfileIsLoading(state),
    datasetError: getError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchCreateDatasetAction: (dataset) => dispatch(datasetActions.createDataset(dataset)),
    dispatchSelectDatasetAction: (data) => dispatch(authSelectDataset(data)),
    dispatchGetDatasetsAction: () => dispatch(datasetActions.getDatasets()),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(SetupPageAcme);
